import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, defaultIfEmpty, map, switchMap, take } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class RouteGuardService {
  constructor(
    public environmentService: EnvironmentService,
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.environmentService
      .getInstanceDetails()
      .pipe(
        defaultIfEmpty(null),
        take(1),
        catchError((err) => {
          console.error('Error getting instance details:', err);
          return of(null);
        }),
        map((details: any) => ({ details })),
        switchMap(detailsObj =>
          this.userService.getRoleDetails().pipe(
            defaultIfEmpty(null),
            take(1),
            catchError((err) => {
              console.error('Error getting role details:', err);
              return of(null);
            }),
            map(roleData => ({ ...detailsObj, roleData }))
          )
        ),
        catchError((err) => {
          console.error('Error in route guard:', err);
          return of({ details: null, roleData: null });
        }),
        map(({ details, roleData }) => {
          if (!details) {
            console.error('RouteGuard: Instance details not available');
            this.router.navigate(['/home']);
            return false;
          }

          if (route?.data?.noSelfServe !== undefined) {
            const instanceNoSelfServe = !!details.no_self_serve;
            const routeRequiresNoSelfServe = route.data.noSelfServe;

            if (instanceNoSelfServe !== routeRequiresNoSelfServe) {
              this.router.navigate(['/home']);
              return false;
            }
          }

          if (route?.data?.feature) {
            if (
              this.environmentService.hasFeature(route?.data?.feature, roleData)
            ) {
              return true;
            }
          }
          const toMatchPasses =
            Array.isArray(route?.data?.toMatch) &&
            route?.data?.toMatch.find(match => match.test(details?.scaffoldType))
              ? true
              : route?.data?.toMatch?.test &&
                route?.data?.toMatch?.test(details?.scaffoldType);

          if (toMatchPasses) {
            return true;
          } else {
            this.router.navigate(['/home']);
            return false;
          }
        }),
        defaultIfEmpty(false)
      );
  }
}